<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
            <fui-row>
                <wbo-price-level-report-selection></wbo-price-level-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
